/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useEditContextNodeId} from "./PermissionHooks";

export const useEditableContextNodeSort = (secondarySort = null) => {
	const canEditContextNodeId = useEditContextNodeId();
	return (a, b) => {
		let aEditable = canEditContextNodeId(a.contextNodeId);
		let bEditable = canEditContextNodeId(b.contextNodeId);
		
		if (aEditable && !bEditable) {
			return -1;
		} else if (!aEditable && bEditable) {
			return 1;
		} else {
			return secondarySort?.(a, b) ?? a.name.localeCompare(b.name);
		}
	}
}
